import React, { useRef, useState } from "react"
import { Spacer } from "../../atoms/Atoms"
import L10n from "lib/carrot-l10n"
import { MultiPathSVG } from "components/views/SVG"
import { useDidMount } from "utils/Hooks"
import { NotSmall, Small } from "../../atoms/Responsive"
import { useWindowEvent } from "utils/hooks/useWindowEvent"
import { FeatureGate } from "../../../../utils/FeatureGate"
import { NavItem } from "./NavItem"
import { BenefitsNav } from "./BenefitsNav"
import { TalkToCarrotBottomPadding, TalkToCarrotNavWrapper } from "./TalkToCarrotNav"
import { SupportCenterNav } from "./SupportCenterNav"
import { YourJourneyNav } from "./YourJourneyNav"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const XButton = ({ onClick }) => (
  <div className="db dn-ns absolute top-0 right-0">
    <button className="bn pa4 bg-transparent" onClick={onClick}>
      <MultiPathSVG iconName="icn-close" />
    </button>
  </div>
)

const NavMenu = ({ collapsed, collapseMenu, appLockedDown }) => {
  const active = collapsed ? "" : "active"
  const markerRef = useRef(null)
  const [isTalkToCarrotButtonFixed, setIsTalkToCarrotButtonFixed] = useState(false)

  const css = collapsed
    ? ""
    : `
  body {
    overflow: hidden;
  }
  `

  const calculateTalkToCarrotPosition = () => {
    const talkToCarrotButtonHeight = 109
    const markerTopOffset = markerRef.current.getBoundingClientRect().top
    const talkToCarrotBottomOffset =
      window.innerHeight - markerTopOffset - talkToCarrotButtonHeight - TalkToCarrotBottomPadding

    // the talkToCarrotBottomOffset is the would-be distance from the bottom of
    // the talk to carrot button (including padding) to the bottom of the
    // viewport. If the value is negative - the talk to carrot button is below
    // the viewport.  If its positive the button is fixed to the bottom of the
    // screen. viewport.
    setIsTalkToCarrotButtonFixed(talkToCarrotBottomOffset > 0)
  }

  useDidMount(calculateTalkToCarrotPosition)
  useWindowEvent("scroll", calculateTalkToCarrotPosition)
  useWindowEvent("resize", calculateTalkToCarrotPosition)

  return (
    <>
      <style>{css}</style>
      <div className={`${active} menu-overlay absolute z-3 top-0 h-100 w-100 bg-black-50`} onClick={collapseMenu} />
      <div
        className={`${active} menu-container z-3 top-0 relative-ns w-100 h-100 h-inherit-ns absolute no-pointer-events`}
      >
        <div className="flex db-ns flex-column justify-center relative h-100 h-inherit-ns mr-80px-s bg-pampas pointer-events">
          <NotSmall>
            <Spacer height={4.375} />
          </NotSmall>
          <XButton onClick={collapseMenu} />
          <NavItem exact id="nav-home-link" link={"/"} text={l`client.home.title`} onClick={collapseMenu} />
          <NotSmall>
            <Spacer height={2.5} />
          </NotSmall>
          <Small>
            <Spacer height={2} />
          </Small>
          <BenefitsNav onClick={collapseMenu} appLockedDown={appLockedDown} />
          <Spacer height={1} />
          <YourJourneyNav onClick={collapseMenu} appLockedDown={appLockedDown} />
          <div className="mh35 bb b--black-10" />
          <Spacer height={1.5} />
          <FeatureGate filter={(c) => c.isSupportCenterEnabled}>
            <SupportCenterNav onClick={collapseMenu} appLockedDown={appLockedDown} />
          </FeatureGate>
          <NotSmall>
            <Spacer height={1} />
            {/* This span is being used as a marker to calculate the would-be position of the talk to carrot button */}
            <span ref={markerRef} />
            {appLockedDown ? null : <TalkToCarrotNavWrapper fixed={isTalkToCarrotButtonFixed} />}
            <Spacer height={1.5} />
          </NotSmall>
        </div>
      </div>
    </>
  )
}

export default NavMenu
